import { memo } from 'react';
import type { FC } from 'react';

import resets from '../../_resets.module.scss';
import classes from './Group.module.scss';
import React from 'react';

interface Props {
  className?: string;
  classes?: {
    root?: string;
  };
}
/* @figmaId 10:7 */
export const Group1: FC<Props> = memo(function Group1(props = {}) {
  return (
    <div className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''}`}>
      <div className={classes.cat1}>
      <div className={classes.categoly}>展示</div></div>
    </div>
  );
});
/* @figmaId 10:7 */
export const Group2: FC<Props> = memo(function Group2(props = {}) {
  return (
    <div className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''}`}>
      <div className={classes.cat2}>
      <div className={classes.categoly}>グッズ</div></div>
    </div>
  );
});
/* @figmaId 10:7 */
export const Group3: FC<Props> = memo(function Group3(props = {}) {
  return (
    <div className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''}`}>
      <div className={classes.cat3}>
      <div className={classes.categoly}>イラスト</div></div>
    </div>
  );
});

/* @figmaId 10:7 */
export const Group4: FC<Props> = memo(function Group4(props = {}) {
  return (
    <div className={`${resets.clapyResets} ${props.classes?.root || ''} ${props.className || ''}`}>
      <div className={classes.cat1}>
      <div className={classes.categoly}>新刊</div></div>
    </div>
  );
});